import { getNamedType, GraphQLType } from "graphql";
import { z } from "zod";

const metadataSchema = z.object({
  description: z.string().optional(),
  type: z.string().optional(),
  enumType: z.string().optional(),
  displayName: z.string().optional(),
  module: z.string().optional(),
  defaultQuery: z.string().optional(),
  queryPermission: z.string().optional(),
  conditionalPolicyPermissions: z
    .string()
    .transform((value) => value.split(","))
    .optional(),
  iconName: z.string().optional(),
  colour: z.string().optional(),
  grouping: z
    .enum(["true", "false"])
    .transform((value) => value === "true")
    .optional(),
  aggregateQuery: z.string().optional(),
});

export function getGraphQLTypeMetadata(input: GraphQLType) {
  const type = getNamedType(input);

  if (!type.description) {
    return null;
  }

  const parsedObject = Object.fromEntries(
    type.description
      .split("\n")
      .map((line) => {
        const [key, ...valueParts] = line.split("=");
        return [key?.trim() ?? "", valueParts.join("=").trim()] as const;
      })
      .filter(([key, value]) => key !== "" && value !== ""),
  );

  return metadataSchema.parse(parsedObject);
}
